import { createGtm } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()

  if (!config.public.gtmId) return

  nuxtApp.vueApp.use(
    createGtm({
      id: config.public.gtmId,
      defer: false,
      compatibility: false,
      enabled: config.public.env === 'production',
      debug: config.public.env === 'development',
      loadScript: true,
      vueRouter: useRouter(),
      trackOnNextTick: false
    })
  )
})
